import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function DiscountItemCard({ item }) {
  return (
    <Card
      sx={{
        width: "100%",
        m: "0px",
        mt: "10px",
        p: "0px",
        ":hover": {
          bgcolor: "#2892ba17",
        },
      }}
    >
      <CardContent sx={{ padding: "0.5rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={5}>
            <Typography
              color="primary"
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              -
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              color="primary"
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              -
            </Typography>
          </Grid>

          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CurrencyRupeeIcon color="primary" fontSize="10px" />
            <Typography
              color="primary"
              sx={{
                textOverflow: "ellipsis",
              }}
            >
              -
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
